import React, { useState } from 'react';
import styled from 'styled-components';
import { FiHome, FiChevronRight } from 'react-icons/fi';
import { assetTheme as t } from './assetTheme';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  color: ${t.muted};
  font-size: 14px;
`

const Crumb = styled.div`
  display: flex;
  align-items: center;
  column-gap: 6px;
  padding: 5px 10px;
  border-radius: 8px;
  cursor: ${({ $isCurrent }) => $isCurrent ? 'default' : 'pointer'};
  font-weight: ${({ $isCurrent }) => $isCurrent ? 700 : 400};
  color: ${({ $isCurrent }) => $isCurrent ? t.text : t.muted};
  background: ${({ $isDragOver }) => $isDragOver ? t.teal100 : 'transparent'};
  outline: ${({ $isDragOver }) => $isDragOver ? `1px dashed ${t.tealDark}` : 'none'};

  &:hover {
    background: ${({ $isCurrent, $isDragOver }) => $isDragOver ? t.teal100 : ($isCurrent ? 'transparent' : '#e9eef2')};
    color: ${({ $isCurrent }) => $isCurrent ? t.text : t.text};
  }
`

const Separator = styled(FiChevronRight)`
  font-size: 12px;
  color: ${t.faint};
`

export default ({
  currentPath = '',
  onNavigate,
  onDropFile
}) => {
  const [dragOverPath, setDragOverPath] = useState(null)

  const segments = currentPath ? currentPath.split('/') : [];

  const crumbs = [
    { name: 'Assets', path: '' },
    ...segments.map((name, i) => ({ name, path: segments.slice(0, i + 1).join('/') }))
  ];

  const buildDropProps = (crumb, isCurrent) => {
    if (isCurrent) return {};
    return {
      onDragOver: (e) => { e.preventDefault(); },
      onDragEnter: (e) => { e.preventDefault(); setDragOverPath(crumb.path); },
      onDragLeave: () => setDragOverPath(null),
      onDrop: (e) => {
        e.preventDefault();
        setDragOverPath(null);
        onDropFile(e, crumb.path);
      }
    }
  }

  return (
    <Wrapper>
      {crumbs.map((crumb, i) => {
        const isCurrent = i === crumbs.length - 1;
        return (
          <React.Fragment key={crumb.path || 'root'}>
            {i > 0 && <Separator />}
            <Crumb
              $isCurrent={isCurrent}
              $isDragOver={dragOverPath === crumb.path && !isCurrent}
              onClick={() => { if (!isCurrent) onNavigate(crumb.path); }}
              {...buildDropProps(crumb, isCurrent)}
            >
              {i === 0 && <FiHome />}
              {crumb.name}
            </Crumb>
          </React.Fragment>
        )
      })}
    </Wrapper>
  )
}
